import React, {useRef, useState, useEffect} from "react";
import styles from "./InfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'

export default function InfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.dangqian_jifen}
        </td>
        <td
            className={styles.td1}
        >{props.item.type==1?"增加":"消耗"}
        </td>
        <td
            className={classNames(styles.td1,props.item.type==1?styles.greenColor:styles.redColor)}
        >{props.item.type==1?"+":"-"}{props.item.jifen}
        </td>
        <td
            className={classNames(styles.td1,props.item.type==1?styles.greenColor:"")}
        >
            {/* {props.item.type==1?"增加":props.item.app_name} */}
            {props.item.type != 1 ? props.item.app_name : props.item.jifen_laiyuan == '1' ? '分配' : '扫码充值'}
        </td>
        {/* <td
            className={styles.td1}
        >{props.item.huihua_id}
        </td> */}
        <td
            className={styles.td1}
        >{props.item.use_time}
        </td>
        <td
            className={classNames(styles.td1,props.item.beizhu==""||props.item.beizhu==null?styles.redColor:"")}
        >{props.item.beizhu==""||props.item.beizhu==null?"----------":props.item.beizhu}
        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

